import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=9cbed0ea&scoped=true&"
import script from "./addForm.vue?vue&type=script&lang=js&"
export * from "./addForm.vue?vue&type=script&lang=js&"
import style0 from "./addForm.vue?vue&type=style&index=0&id=9cbed0ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbed0ea",
  null
  
)

export default component.exports